var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69107 4.25483L1.30795 8.32932C1.06402 8.55608 1.06402 8.92486 1.30795 9.15162L5.69107 13.2261C5.93332 13.4513 6.32479 13.4513 6.56705 13.2261C6.81098 12.9993 6.81098 12.6306 6.56705 12.4038L3.20289 9.27653H16.3125L16.4136 9.2682C16.676 9.22441 16.875 9.01325 16.875 8.75936C16.875 8.47373 16.6232 8.24219 16.3125 8.24219H3.15853L6.56705 5.07714C6.81098 4.85038 6.81098 4.48159 6.56705 4.25483C6.32479 4.02964 5.93332 4.02964 5.69107 4.25483Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 16,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69107 4.25483L1.30795 8.32932C1.06402 8.55608 1.06402 8.92486 1.30795 9.15162L5.69107 13.2261C5.93332 13.4513 6.32479 13.4513 6.56705 13.2261C6.81098 12.9993 6.81098 12.6306 6.56705 12.4038L3.20289 9.27653H16.3125L16.4136 9.2682C16.676 9.22441 16.875 9.01325 16.875 8.75936C16.875 8.47373 16.6232 8.24219 16.3125 8.24219H3.15853L6.56705 5.07714C6.81098 4.85038 6.81098 4.48159 6.56705 4.25483C6.32479 4.02964 5.93332 4.02964 5.69107 4.25483Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.984375,
    width: 18,
    height: 16.5495,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.e6e2e402bde130947fe0c239ffab4cab.svg";
export { ForwardRef as ReactComponent };